// extracted by mini-css-extract-plugin
export var statItem = "_ky-1";
export var statsRow = "_ky-0";